module.exports = __webpack_public_path__ + "static/media/after.ae6a18a2.png";